export default __webpack_public_path__ + "static/media/pattern-circle2.ecd4ed13.jpg";